export default "__VITE_ASSET__gy30FUdS__"